// React Imports
import type { SVGAttributes } from 'react'

const DirectionLtr = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='104' height='66' viewBox='0 0 104 66' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='104' height='66' rx='4' fill='currentColor' fillOpacity='0.02' />
      <rect x='5.20215' y='4.12146' width='24.0976' height='57.5885' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect
        x='10.3232'
        y='16.8697'
        width='13.8545'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='10.3232'
        y='25.5618'
        width='9.87943'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='10.3232'
        y='34.2538'
        width='12.3826'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='10.3232' y='42.946' width='6.08818' height='2.0921' rx='1.04605' fill='currentColor' fillOpacity='0.3' />
      <rect
        x='10.3232'
        y='51.6384'
        width='8.09094'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='35.5137' y='4.12134' width='62.3885' height='57.5885' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect
        x='43.7578'
        y='14.1833'
        width='13.8545'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='43.7578'
        y='22.8753'
        width='32.8013'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='43.7578'
        y='31.5674'
        width='41.2076'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='43.7578'
        y='40.2593'
        width='32.8013'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='43.7578'
        y='48.9517'
        width='5.77482'
        height='2.0921'
        rx='1.04605'
        fill='currentColor'
        fillOpacity='0.3'
      />
    </svg>
  )
}

export default DirectionLtr
